import type { PathPattern } from "./types";

export function matchPath(
  urlOrPath: string,
  patterns: PathPattern[] | undefined,
): boolean {
  if (!patterns?.length) return false;
  const path = getPathFromUrl(urlOrPath);

  return patterns.some((pattern) => {
    if (typeof pattern === "string") {
      const exact = path === pattern;
      const prefix = pattern.endsWith("/")
        ? path.startsWith(pattern)
        : path.startsWith(`${pattern}/`);
      return exact || prefix;
    }

    return pattern.test(path);
  });
}

function getPathFromUrl(urlOrPath: string): string {
  try {
    if (urlOrPath.startsWith("http")) {
      const url = new URL(urlOrPath);
      return url.pathname;
    }

    const pathOnly = urlOrPath.split("?")[0];
    return pathOnly || urlOrPath;
  } catch {
    return urlOrPath;
  }
}
